export default __webpack_public_path__ + "static/media/search.3a2cdee2.svg";